import React, {useState, useEffect} from 'react'

let Lobby = ({room, players, isHost, wid, decks, selectedDeck, onHost, onJoin, onStart, onSelectDeck, screenWidth, screenHeight}) => {
  let [joinId, setJoinId] = useState('')
  let [showJoin, setShowJoin] = useState(false)
  let [showPicker, setShowPicker] = useState(false)
  let [fade, setFade] = useState(0)

  useEffect(() => {
    let t = setTimeout(() => setFade(1), 10)
    return () => clearTimeout(t)
  }, [])

  let pickDeck = deck => {
    onSelectDeck(deck)
    setShowPicker(false)
  }

  // Deck picker overlay
  if (showPicker) {
    return (
      <div style={{...s.full, width: screenWidth, height: screenHeight}}>
        <div style={{width: 240, maxHeight: screenHeight * 0.6, overflow: 'auto'}}>
          <div style={{color: '#666', fontSize: 12, marginBottom: 12, textAlign: 'center'}}>
            select a deck
          </div>
          {decks.length === 0 && (
            <div style={{color: '#555', fontSize: 14, textAlign: 'center'}}>no decks found</div>
          )}
          {decks.map(d => {
            let cardCount = d.stacks?.reduce((sum, st) => sum + (st.cards?.length || 0), 0) || 0
            let isSelected = selectedDeck?.id === d.id
            return (
              <div
                key={d.id}
                onClick={() => pickDeck(d)}
                style={{
                  ...s.deckRow,
                  borderColor: isSelected ? '#888' : '#555',
                }}>
                <div style={{color: '#888', fontSize: 14}}>{d.name}</div>
                <div style={{color: '#555', fontSize: 12}}>{cardCount}</div>
              </div>
            )
          })}
          <div onClick={() => setShowPicker(false)} style={{...s.deckRow, justifyContent: 'center', borderTopWidth: 1}}>
            <div style={{color: '#666', fontSize: 14}}>cancel</div>
          </div>
        </div>
      </div>
    )
  }

  // In a room — show room info
  if (room) {
    return (
      <div style={{...s.full, width: screenWidth, height: screenHeight}}>
        <div style={{transition: 'opacity 400ms', opacity: fade}}>
          <div style={s.roomCode}>
            <span style={{opacity: 0.4}}>#</span>
            {room}
          </div>
          <div style={s.playerCount}>
            {players.length} / 4 players
          </div>
          <div style={s.playerList}>
            {players.map((p, i) => {
              let isMe = p.wid === wid
              return (
                <div key={p.wid} className={'flexRow'} style={{alignItems: 'center', gap: 8}}>
                  <div style={s.player}>
                    {p.name}{i === 0 ? ' (host)' : ''}
                  </div>
                  <div
                    onClick={isMe ? () => setShowPicker(true) : undefined}
                    style={{
                      width: 20,
                      height: 20,
                      border: '1px solid #555',
                      borderRadius: 2,
                      backgroundColor: p.deck ? '#555' : 'transparent',
                      cursor: isMe ? 'pointer' : 'default',
                    }}
                  />
                </div>
              )
            })}
          </div>
          {isHost && (
            <div onClick={onStart} style={s.startBtn}>
              start
            </div>
          )}
        </div>
      </div>
    )
  }

  // No room — show host/join
  return (
    <div style={{...s.full, width: screenWidth, height: screenHeight}}>
      <div style={{transition: 'opacity 600ms', opacity: fade}}>
        <div onClick={onHost} style={s.btn}>
          host
        </div>
        {showJoin ? (
          <div className={'flexRow'} style={{marginTop: 0}}>
            <div style={s.joinBox}>
              <span style={{opacity: 0.4, marginRight: 4}}>#</span>
              <input
                autoFocus
                type="number"
                inputMode="numeric"
                style={s.input}
                value={joinId}
                onChange={e => setJoinId(e.target.value)}
                placeholder="000000"
              />
            </div>
            {joinId.length >= 6 && (
              <div onClick={() => onJoin(joinId)} style={s.goBtn}>
                +
              </div>
            )}
          </div>
        ) : (
          <div onClick={() => setShowJoin(true)} style={s.btn}>
            join
          </div>
        )}
      </div>
    </div>
  )
}

export default Lobby

let s = {
  full: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1a1a1a',
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 100,
    paddingLeft: 10,
    color: '#888',
    fontSize: 16,
    border: '1px solid #555',
    borderBottomWidth: 0,
    cursor: 'pointer',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  joinBox: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 100,
    paddingLeft: 10,
    color: '#888',
    fontSize: 16,
    border: '1px solid #555',
    borderTopWidth: 0,
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  input: {
    backgroundColor: 'transparent',
    border: 'none',
    width: 70,
    height: 48,
    fontSize: 16,
    color: '#888',
    outline: 'none',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  goBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    width: 50,
    color: '#888',
    fontSize: 20,
    border: '1px solid #555',
    borderTopWidth: 0,
    borderLeftWidth: 0,
    cursor: 'pointer',
  },
  roomCode: {
    color: '#888',
    fontSize: 32,
    textAlign: 'center',
    marginBottom: 16,
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  playerCount: {
    color: '#666',
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 20,
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  playerList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    marginBottom: 24,
  },
  player: {
    color: '#888',
    fontSize: 14,
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  startBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    width: 100,
    color: '#888',
    fontSize: 16,
    border: '1px solid #555',
    cursor: 'pointer',
    margin: '0 auto',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
  deckRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    border: '1px solid #555',
    borderTopWidth: 0,
    cursor: 'pointer',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 300,
  },
}
